import { createSlice } from "@reduxjs/toolkit";

const defaultPagination = {
  page: 0,
  pageSize: 50,
};

const baseFilterState = {
  pagination: { ...defaultPagination },
  search: "",
  manager: "",
  clientId: { value: "", label: "" },
  country: "",
  branchId: { value: "", label: "" },
  taxType: "",
  teamIds: [],
  projectsCount: "",
  totalWorkOrdersCount: "",
  publishedCount: "",
  assignedCount: "",
  workDoneCount: "",
  approvedCount: "",
  paidCount: "",
};

const initialState = {
  workOrders: { ...baseFilterState },
  customerWorkOrders: { ...baseFilterState },
  childClients: { ...baseFilterState },
};

const clientDashboardFilterSlice = createSlice({
  name: "clientDashboardFilters",
  initialState,
  reducers: {
    setClientDashboardFilters: (state, action) => {
      const { module, filterName, data } = action.payload;

      if (!state[module]) return;

      if (filterName === "pagination") {
        state[module].pagination = {
          ...state[module].pagination,
          ...data,
        };
      }
      else if (filterName.includes(".")) {
        const [parent, child] = filterName.split(".");
        if (state[module][parent] !== undefined) {
          state[module][parent][child] = data;
        }
      }
      else {
        state[module][filterName] = data;
      }
    },

    resetClientDashboardFilters: (state, action) => {
      const { module } = action.payload;
      if (initialState[module]) {
        state[module] = { ...baseFilterState };
      }
    },

    resetClientDashboardPagination: (state, action) => {
      const { module } = action.payload;
      if (state[module]) {
        state[module].pagination = { ...defaultPagination };
      }
    },
  },
});

export const {
  setClientDashboardFilters,
  resetClientDashboardFilters,
  resetClientDashboardPagination,
} = clientDashboardFilterSlice.actions;

export default clientDashboardFilterSlice.reducer;
